<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">การยืนยันตัวตนแบบ 2 ขั้นตอน</h2>
    </div>
    <v-card outlined class="pa-4">
      <v-checkbox
        v-model="twoFactorAuthConfig.admin.is_enable"
        class="mt-0 d-inline-block"
        label="เปิดใช้งานสำหรับผู้ดูแลระบบ"
        hide-details
      ></v-checkbox>
      <div class="ml-8">
        <v-divider class="my-2"></v-divider>
        <label class="body-2"> วิธีการยืนยันตัวตนแบบ 2 ขั้นตอน </label>
        <div class="mt-1" style="width: 240px">
          <v-select
            v-model="twoFactorAuthConfig.admin.method"
            :items="adminMethods"
            item-text="label"
            item-value="value"
            outlined
            dense
          ></v-select>
        </div>
      </div>
    </v-card>
    <v-card outlined class="pa-4 mt-4">
      <v-checkbox
        v-model="twoFactorAuthConfig.employee.is_enable"
        class="mt-0 d-inline-block"
        label="เปิดใช้งานสำหรับพนักงาน"
        hide-details
      ></v-checkbox>
      <div class="ml-8">
        <v-divider class="my-2"></v-divider>
        <label class="body-2"> วิธีการยืนยันตัวตนแบบ 2 ขั้นตอน </label>
        <div class="mt-1" style="width: 240px">
          <v-select
            v-model="twoFactorAuthConfig.employee.method"
            :items="employeeMethods"
            item-text="label"
            item-value="value"
            outlined
            dense
          ></v-select>
        </div>
        <v-divider class="mb-2"></v-divider>
        <label class="body-2"> การดำเนินการเมื่อพนักงานไม่มีอีเมล </label>
        <v-radio-group
          v-model="
            twoFactorAuthConfig.employee.is_allowed_if_method_unavailable
          "
          row
        >
          <v-radio
            label="ข้ามการยืนยันตัวตนแบบ 2 ขั้นตอน"
            :value="true"
          ></v-radio>
          <v-radio label="ไม่อนุญาตให้เข้าใช้งาน" :value="false"></v-radio>
        </v-radio-group>
      </div>
    </v-card>
    <div class="mt-4 mb-10">
      <v-btn
        class="mr-2"
        color="primary"
        :disabled="
          !isTwoFactorAuthConfigDataChange ||
          (uiCtrl && !uiCtrl.isEnable('btn:::company_config:2fa_config:update'))
        "
        @click="onSave"
        >บันทึก</v-btn
      >
      <v-btn @click="onCancel">ยกเลิก</v-btn>
    </div>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'TwoFactorAuth',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      twoFactorAuthConfig: {
        admin: {},
        employee: {},
      },
      twoFactorAuthConfigInit: {
        admin: {},
        employee: {},
      },
      adminMethods: [{ id: 1, label: 'อีเมล', value: 'email' }],
      employeeMethods: [{ id: 1, label: 'อีเมล', value: 'email' }],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isTwoFactorAuthConfigDataChange() {
      if (
        this.twoFactorAuthConfig.admin.is_enable !==
          this.twoFactorAuthConfigInit.admin.is_enable ||
        this.twoFactorAuthConfig.employee.is_enable !==
          this.twoFactorAuthConfigInit.employee.is_enable ||
        this.twoFactorAuthConfig.admin.method !==
          this.twoFactorAuthConfigInit.admin.method ||
        this.twoFactorAuthConfig.employee.method !==
          this.twoFactorAuthConfigInit.employee.method ||
        this.twoFactorAuthConfig.employee.is_allowed_if_method_unavailable !==
          this.twoFactorAuthConfigInit.employee.is_allowed_if_method_unavailable
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    uiCtrl(value) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('menu:::company_config:2fa_config')
      ) {
        this.$router.push({ name: 'Home' })
      } else if (value) {
        this.loadData()
      }
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การยืนยันตัวตนแบบ 2 ขั้นตอน',
        disabled: true,
      },
    ])

    if (
      this.uiCtrl &&
      this.uiCtrl.isEnable('menu:::company_config:2fa_config')
    ) {
      this.loadData()
    }
  },
  methods: {
    ...mapActions({
      fetchTwoFactorAuthConfig: 'company/fetchTwoFactorAuthConfig',
      editTwoFactorAuthConfig: 'company/editTwoFactorAuthConfig',
    }),
    onSave() {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      this.editTwoFactorAuthConfig({
        company_uuid,
        data: this.twoFactorAuthConfig,
      })
        .then(() => {
          this.$store.state.loading = false

          this.twoFactorAuthConfigInit = JSON.parse(
            JSON.stringify(this.twoFactorAuthConfig)
          )

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'บันทึกข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onCancel() {
      this.twoFactorAuthConfig = JSON.parse(
        JSON.stringify(this.twoFactorAuthConfigInit)
      )
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      this.fetchTwoFactorAuthConfig(company_uuid)
        .then(() => {
          this.$store.state.loading = false

          this.twoFactorAuthConfig = JSON.parse(
            JSON.stringify(this.$store.state.company.twoFactorAuthConfig)
          )
          this.twoFactorAuthConfigInit = JSON.parse(
            JSON.stringify(this.$store.state.company.twoFactorAuthConfig)
          )
        })
        .catch((error) => {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      this.confirmDialogDataChange = false
      this.nextRoute(item.data)
    },
    nextRoute(next) {
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isTwoFactorAuthConfigDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
